import { removed } from '../../util/console';
import Vue from 'vue';
export default Vue.extend().extend({
    name: 'bootable',
    props: {
        eager: Boolean
    },
    data: () => ({
        isBooted: false
    }),
    computed: {
        hasContent() {
            return this.isBooted || this.eager || this.isActive;
        }
    },
    watch: {
        isActive() {
            this.isBooted = true;
        }
    },
    created() {
        if ('lazy' in this.$attrs) {
            removed('lazy', this);
        }
    },
    methods: {
        showLazyContent(content) {
            return this.hasContent && content ? content() : [this.$createElement()];
        }
    }
});
